import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Grid,
  Container,
  Button,
  Paper,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";

const CreateUser = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(""); 
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const navigate = useNavigate();
  const token = localStorage.getItem("access_token");

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/user`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            fname: firstName,
            lname: lastName,
            email,
            password,
            role,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setError(data.msg || "Something went wrong. Please try again.");
        setSnackbar({
          open: true,
          message: data.msg || "Something went wrong. Please try again.",
          severity: "error",
        });
      } else {
        setSuccess("User Added Successfully!");
        setSnackbar({
          open: true,
          message: "User created successfully!",
          severity: "success",
        });
        
        setTimeout(() => {
          setFirstName("");
          setLastName("");
          setEmail("");
          setPassword("");
          setRole(""); 
        }, 3000); 
      }
    } catch (err) {
      setError("Network error. Please try again later.");
      setSnackbar({
        open: true,
        message: "Network error. Please try again later.",
        severity: "error",
      });
    }
  };

  return (
    <Container maxWidth="md">
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
        <Typography variant="h5" gutterBottom >
          Create User
        </Typography>
        <form onSubmit={handleSendOtp} className="auth-form">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                fullWidth
                variant="outlined"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                fullWidth
                variant="outlined"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                fullWidth
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Password"
                fullWidth
                variant="outlined"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Role"
                fullWidth
                variant="outlined"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              />
            </Grid>
          </Grid>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <Button
            type="submit"
            variant="contained"
            color="primary"className="athrv-dash-primary-button" sx={{width: '150px', marginTop: '10px'}}
          >
            Create User
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default CreateUser;